import React          from 'react';
import classnames     from 'classnames';
import connectField   from 'uniforms/connectField';
import filterDOMProps from 'uniforms/filterDOMProps';

import {
  FormControl,
  Col,
  Button
} from '@sketchpixy/rubix';

import AutoField from 'uniforms-bootstrap3/AutoField';
import SelectField from 'uniforms-bootstrap3/SelectField';

const DynamicListAdd = ({
    addIcon,
    className,
    disabled,
	onChange,
    parent,
    value,
	valueList,
    ...props
}) => {
    const limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
	let selectRef = null;

    return (
    	<Col sm={12}>
			<div>
				{ valueList && valueList.length > 0 &&
					<div>
						<Col sm={10}>
							<FormControl componentClass="select" type="select" inputRef={(input) => { selectRef = input; }}>
								{ valueList.map((item) =>
									<option value={ item._id }>
										{ item.username &&
											<span>{ item.username }</span>
										}
										</option>
								)}
							</FormControl>
						</Col>
						<Col sm={2}>
							<div
								onClick={() => limitNotReached && !parent.value.includes(selectRef.value) && parent.onChange(parent.value.concat([selectRef.value]))}
								{...filterDOMProps(props)}
							>
								{addIcon}
							</div>
						</Col>
					<br/><br/></div>
				}
			</div>
		</Col>
    );
};

DynamicListAdd.defaultProps = {
    addIcon: <Button bsStyle="success">Ajouter</Button>,
	valueList: []
};

export default connectField(DynamicListAdd, {includeParent: true, initialValue: false});



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/DynamicListAddField.js
 **/